module.exports = __webpack_public_path__ + "static/media/icon_wifi-off.e845ed42.svg";